export enum PatientType {
    ALL = 1,
    INDIVIDUAL = 2,
    CORPORATE = 3,
    SPECIFIC = 4,
}
